module.exports = __webpack_public_path__ + "static/media/furniture4.3e31bb2d.jpg";